import { storeCreator } from '@/utils/store/store.utils';

interface State {
  externalId?: string;
  handleSetExternalId: (value: string) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  externalId: undefined,
  handleSetExternalId: (value: string) => set((state) => ({
    ...state,
    externalId: value,
  })),

  handleReset: () => set((state) => ({
    ...state,
    externalId: undefined,
  })),
}));
